import { openMailto } from "@/utils/mailto";
import WhyDeveloperImage from "@assets/images/why-developers.png";
import VisiblityDashboard from "@assets/images/new-dashboard.png";
import heroImage from "@assets/images/Group 1410087705.svg";
import emergencyIcon from "@assets/icons/emergencyIcon.svg";
import InfoAccordion from "../components/accordion";
import {
  services,
  features,
  partnership,
  whyChooseGaz,
  collectionServiceDetails,
  keyIndustryServed,
} from "../data";
import Help from "../components/help";
import Hero from "../components/hero";

const heroData = {
  title:
    "Your Gas Infrastructure Partner for Buildings, Communities & Businesses",
  description:
    "We deliver end-to-end solutions for property developers, owner associations, and commercial clients from network design and installation to metering, billing, and maintenance.",
  image: heroImage,
  buttonText: "Book a consultation",
  buttonOnclick: () =>
    openMailto({
      subject: "Business Consultation Request",
      body: "Hello,\n\nI would like to book a consultation regarding business gas solutions.\n\nCompany:\nContact Person:\nPhone:\n",
    }),
  footerText:
    "Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business.",
  footerButtonText: "Report an Emergency Online",
  footerButtonOnclick: () =>
    openMailto({
      subject: "Emergency Report",
      body: "Emergency Type:\nLocation:\nDescription:\n",
    }),
  footerIcon: <img src={emergencyIcon} alt="" className="w-7 h-7" />,
};

function BusinessSolution() {
  return (
    <div className="bg-white">
      <Hero data={heroData} />

      {/* CORPORATE SERVICE PORTFOLIO SECTION */}
      <section className="py-10 md:py-14 lg:py-[110px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto">
          <h2 className="text-[24px] md:text-[40px] lg:text-[56px] font-semibold text-gis-dark-blue text-center">
            Our Corporate Service Portfolio
          </h2>

          <div className="grid gap-4 mt-5 md:mt-8 md:grid-cols-2 lg:mt-16 lg:grid-cols-3">
            {services.map((service, index) => (
              <article
                key={index}
                className="p-3 md:p-6 border border-[#62636C33] rounded-[12px] md:rounded-[24px]"
              >
                <div className="flex flex-row items-center gap-3">
                  <div className="bg-black size-10 md:size-[50px] lg:size-[68px] grid place-content-center rounded-md md:rounded-[12px] flex-shrink-0">
                    <span className="text-xs font-semibold text-white md:text-base">
                      0{index + 1}
                    </span>
                  </div>
                  <h3 className="text-[#090D2C] text-sm md:text-lg lg:text-xl font-semibold leading-[1.1]">
                    {service.title}
                  </h3>
                </div>
                <p className="mt-4 text-[14px] md:text-xs md:mt-6 lg:text-sm">
                  {service.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* WHY CHOOSE DEVELOPER SECTION */}
      <section className="py-10 xl:py-[110px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto">
          <div className="flex flex-col-reverse items-start justify-between gap-10 xl:flex-row">
            <img
              src={WhyDeveloperImage}
              alt="why developer image"
              className="sm:h-[500px] xl:h-auto xl:max-w-[664px] object-cover object-bottom"
            />
            <div className="xl:max-w-[615px]">
              <h2 className="text-gis-dark-blue font-bold text-[24px] md:text-[40px] lg:text-[54px]">
                Why Developers & OA Choose GAZ
              </h2>
              <div className="mt-5 lg:mt-[60px]">
                {whyChooseGaz.map((data, index) => (
                  <InfoAccordion
                    data={data}
                    key={index}
                    isDefaultOpen={index === 0}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PATNERSHIP STRUCTURES */}
      <section className="pb-10 md:pb-[100px] pt-5 md:pt-[50px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto">
          <div className="bg-[#F1F1F1] rounded-[16px] md:rounded-[24px] p-4 md:p-7 lg:p-10">
            <h2 className="text-[24px] md:text-[30px] lg:text-[40px] font-semibold text-[#1E1F24]">
              Flexible Partnership Structures
            </h2>

            <div className="grid gap-6 mt-5 md:grid-cols-2 lg:mt-10">
              {partnership.map((data, index) => (
                <article
                  key={index}
                  className="p-3 md:p-6 bg-white border border-[#62636C33] rounded-[12px] md:rounded-[24px]"
                >
                  <h3 className="text-[#090D2C] font-semibold text-sm md:text-base lg:text-xl">
                    {data.title}
                  </h3>
                  <p className="mt-3 md:mt-6 text-[14px] md:text-xs lg:text-sm text-[#0A0E2EBF]">
                    {data.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SMART SUB METERING */}
      <section className="py-10 md:py-20 lg:py-[100px] px-5 md:px-10 bg-[#F1F1F1]">
        <div className="w-[1368px] max-w-full mx-auto flex flex-col xl:flex-row gap-10 justify-between items-start">
          <div className="xl:max-w-[700px]">
            <h2 className="text-gis-dark-blue font-semibold text-[24px] md:text-[40px] lg:text-[54px] max-w-[600px]">
              Smart Sub-Metering for Multi-Tenant Buildings
            </h2>
            <p className="mt-5 text-[14px] md:text-base text-[#62636C]">
              GAZ provides centralized bulk metering with individual tenant
              sub-meters. Our platform generates digital invoices, collects
              payments, and remits funds to developers or OAs transparently.
            </p>
          </div>
          <div className="xl:max-w-[520px]">
            <span className="py-2 px-8 md:px-12 inline-block text-[14px] md:text-base bg-[#FEF6F4] text-[#62636C] rounded-lg border border-orangered font-semibold">
              Features
            </span>
            <div className="mt-4 space-y-2">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center gap-3">
                  <span className="flex-shrink-0 rounded-full size-2 md:size-3 bg-gis-red" />
                  <span className="text-[#62636C] text-[14px] md:text-base">
                    {feature}
                  </span>
                </li>
              ))}
            </div>
          </div>
        </div>

        <div className="w-[1368px] max-w-full mx-auto mt-20 md:mt-[140px]">
          <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[60px] font-semibold text-center">
            Protecting Your People and Property
          </h2>
          <div className="flex flex-col gap-6 mt-6 md:mt-12 md:flex-row">
            <div className="bg-white rounded-[12px] md:rounded-[24px] p-3 md:p-6 flex-1">
              <h3 className="text-[#090D2C] font-semibold text-base md:text-xl">
                Offerings
              </h3>
              <div className="mt-2 space-y-2 md:mt-4">
                {[
                  "Periodic inspection and preventive maintenance programs",
                  "Pressure testing and leak audits",
                  "Equipment replacement and calibration",
                  "24/7 emergency response with guaranteed SLA (≤ 60 minutes)",
                  "Digital maintenance reports accessible via portal ",
                ].map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <span className="flex-shrink-0 size-2 md:size-3 bg-[#62636C] rounded-full" />
                    <span className="text-[#62636C] text-[14px] md:text-base">
                      {feature}
                    </span>
                  </li>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-[12px] md:rounded-[24px] p-3 md:p-6 flex-1">
              <h3 className="text-[#090D2C] font-semibold text-base md:text-xl">
                Add Ons
              </h3>
              <p className="mt-1 md:mt-4 text-[#62636C] text-[14px] md:text-base">
                Governance decisions follow:
              </p>
              <div className="mt-2 space-y-2">
                {[
                  "Gas detector installation and monitoring",
                  "Fire-gas integration with BMS",
                  "Annual Civil Defense safety certification",
                ].map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <span className="flex-shrink-0 size-2 md:size-3 bg-[#62636C] rounded-full" />
                    <span className="text-[#62636C] text-[14px] md:text-base">
                      {feature}
                    </span>
                  </li>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BILLING AND COLLECTION SERVICE SECTION */}
      <section className="py-10 md:py-20 lg:py-[120px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto">
          <h2 className="text-gis-dark-blue text-[24px] md:text-[40px] lg:text-[54px] font-semibold text-center">
            Billing & Collection Service Details
          </h2>

          <div className="mt-10 lg:mt-[90px] space-y-4">
            {collectionServiceDetails.map((data, index) => (
              <article
                key={index}
                className="p-1 sm:p-4 border-b border-[#62636C33]"
              >
                <div className="flex items-start justify-between gap-2 sm:items-center">
                  <h3 className="text-xs md:text-base lg:text-xl text-[#090D2C] font-semibold leading-snug">
                    {data.title}
                  </h3>
                  <span
                    style={{
                      backgroundColor: data.bgColor,
                      color: index === 1 ? "black" : "white",
                    }}
                    className="py-1 sm:py-2 px-2 sm:px-3 text-[10px] text-nowrap md:text-[14px] lg:text-xs rounded-md border border-[#62636C33]"
                  >
                    Charged: <strong>{data.charged}</strong>
                  </span>
                </div>
                <p className="mt-1 sm:mt-2 text-[14px] md:text-xs lg:text-base text-[#0A0E2EBF]">
                  {data.desc}
                </p>
              </article>
            ))}
          </div>

          <div className="text-[12px] md:text-xs lg:text-base text-[#62636C] mt-8 md:mt-14 lg:mt-[90px] px-3 md:px-12 py-3 bg-[#FEF6F4] border border-[#F03813] rounded-lg">
            <strong>NOTE! </strong>
            <span>
              All corporate contracts can integrate these fees directly into
              tenant invoices, ensuring seamless cost recovery.
            </span>
          </div>
        </div>
      </section>

      {/* TOTAL VISIBILITY SECTION */}
      <section className="pt-5 md:pt-16 lg:pt-[100px] pb-[50px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto flex flex-col lg:flex-row justify-between gap-10">
          <div className="lg:max-w-[644px]">
            <h2 className="text-gis-dark-blue text-[24px] md:text-[40px] lg:text-[54px] font-semibold">
              Total Visibility. <br />
              Complete Control.
            </h2>
            <div className="p-0 md:p-10">
              <p className="mt-4 text-[#62636C] text-[14px] md:text-base">
                Capabilities:
              </p>
              <div className="mt-2 space-y-2 md:space-y-3.5">
                {[
                  "Building wide consumption tracking ",
                  "Real-time outstanding balances ",
                  "Collection performance analytics ",
                  "Maintenance SLA tracking ",
                  "Downloadable monthly performance pack (PDF/XLS) ",
                ].map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <span className="flex-shrink-0 rounded-full size-2 md:size-3 bg-orangered" />
                    <span className="text-[#62636C] text-[14px] md:text-base">
                      {feature}
                    </span>
                  </li>
                ))}
              </div>
            </div>
          </div>
          <img
            src={VisiblityDashboard}
            alt="Visibility Dashboard"
            className="lg:w-[500px] xl:w-[647px]"
          />
        </div>
      </section>

      {/* KEY INDUSRIES SERVED SECTION */}
      <section className="pt-8 md:pt-[60px] pb-20 md:pb-[120px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto bg-[#F1F1F1] rounded-lg p-4 md:p-10 pt-10 md:pt-[60px]">
          <h2 className="text-gis-dark-blue text-[24px] md:text-[32px] lg:text-[40px] font-semibold">
            Key Industries Served
          </h2>

          <div className="grid grid-cols-1 gap-4 mt-5 md:gap-6 md:grid-cols-2 md:mt-10 lg:mt-20 xl:grid-cols-4">
            {keyIndustryServed.map((data, index) => (
              <article
                key={index}
                className="p-3 md:p-6 rounded-[12px] md:rounded-[24px] bg-white"
              >
                <h4 className="text-sm md:text-lg font-semibold text-[#1C1C1C] xl:min-h-16">
                  {data.title}
                </h4>
                <p className="mt-6 text-[14px] md:text-xs text-[#0A0E2EBF]">
                  {data.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CORPORATE OPERATIONS */}
      <section className="py-10 md:py-20 lg:py-[120px] px-5 md:px-10 bg-[#F1F1F1]">
        <div className="w-[1368px] max-w-full mx-auto">
          <h2 className="text-gis-dark-blue text-[24px] md:text-[36px] lg:text-[48px] font-semibold">
            All GAZ corporate operations adhere to:
          </h2>
          <div className="space-y-3 mt-7">
            {[
              "UAE Fire & Life Safety Code of Practice (2021) ",
              "Dubai Civil Defense LPG Guidelines",
              "Emirates Authority for Standardization & Metrology (ESMA) ",
              "Federal Tax Authority (FTA) VAT requirements ",
            ].map((feature, index) => (
              <li key={index} className="flex items-center gap-3">
                <span className="rounded-full flex-shrink-0 size-2 md:size-3 bg-[#62636C]" />
                <span className="text-[#62636C] text-[14px] md:text-base">
                  {feature}
                </span>
              </li>
            ))}
          </div>

          <span className="border-b border-[#B9BBC6] inline-block w-full my-10 md:my-16"></span>

          <h2 className="text-gis-dark-blue text-[24px] md:text-[36px] lg:text-[48px] font-semibold">
            Helping You Meet UAE Net Zero 2050 Goals
          </h2>
          <div className="space-y-3 mt-7">
            {[
              "Smart metering reduces energy waste through real-time visibility. ",
              "Efficient pressure control minimizes gas loss. ",
              "Leak-detection technology improves safety and reduces emissions. ",
              "Optional data analytics for carbon-footprint reporting. ",
            ].map((feature, index) => (
              <li key={index} className="flex items-center gap-3">
                <span className="rounded-full flex-shrink-0 size-2 md:size-3 bg-[#62636C]" />
                <span className="text-[#62636C] text-[14px] md:text-base">
                  {feature}
                </span>
              </li>
            ))}
          </div>
        </div>
      </section>

      {/* HELP SECTION */}
      <Help />
    </div>
  );
}

export default BusinessSolution;
